export default "__VITE_ASSET__SAmgAUa4__";